import React from 'react'
import { observer } from 'mobx-react-lite'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import { TableCell } from '@material-ui/core'
import { IntegrationType } from '../../../../server/mpsklad_core/Entity/IntegrationType'
import { IServerTableData } from '../../../../types/tableTypes'
import { ExternalProductModel } from '../../../../server/mpsklad_core/Models/ExternalProductModel'
import { ProductsTableProps } from '../productsTable'
import { MyTableHead } from '../../../../components/Tables/MyTableHead'
import { AccountModelBase } from '../../../../server/mpsklad_core/Models/AccountModelBase'

interface HeaderProps<
  TProducts extends IServerTableData<TRow, TColumnId>,
  TRow extends ExternalProductModel,
  TColumnId extends string> extends Pick<ProductsTableProps<TProducts, TRow, TColumnId>, 'columns' | 'products'> {
  account: AccountModelBase
}

export const Header = observer(<TProducts extends IServerTableData<TRow, TColumnId>,
  TRow extends ExternalProductModel,
  TColumnId extends string>({columns, products, account}: HeaderProps<TProducts, TRow, TColumnId>) => {
  const classes = useStyles()

  const getIntegrationInfo = (type: IntegrationType) => {
    switch (type) {
      case IntegrationType.Ozon:
        return {title: 'Ozon', className: 'ozon'}
      case IntegrationType.Wildberries:
        return {title: 'Wildberries', className: 'wildberries'}
      case IntegrationType.YandexMarket:
        return {title: 'Yandex.Market', className: 'yandexMarket'}
      case IntegrationType.MoySklad:
        return {title: 'МойСклад', className: 'moysklad'}
      default: {
        const _exhaustive: never = type
        throw new Error(`Unsupported integration type: ${_exhaustive}`)
      }
    }
  }

  const {title, className} = getIntegrationInfo(account.integrationType)

  const colSpan = columns.length || 1

  return (
    <MyTableHead
      table={products}
      visibleColumns={columns}
      groupHeader={
        <TableCell
          colSpan={colSpan}
          className={clsx(classes.groupCell, className)}
          style={{borderRight: 'none', borderTopRightRadius: 5}}
        >
          {title}
        </TableCell>
      }
    />
  )
})

const useStyles = makeStyles(({palette}) => ({
  groupCell: {
    padding: '4px 15px',
    borderTopLeftRadius: 5,
    borderRight: `2px solid ${palette.mpSkladSecondary.lightGray}`,
    height: 32,
    color: palette.mpSkladSecondary.lightBlue,
    fontWeight: 700
  },
  moysklad: {
    background: '#2855af'
  },
  ozon: {
    background: '#005BFF'
  },
  wildberries: {
    background: '#BC3D96'
  },
  yandexMarket: {
    background: '#FC0'
  }
}))
